import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./pages/Auth/Login/Login";
import { PrivateRoute, privateRoutes } from "./services/privateRoute.utils";
import PageNotFound from "./pages/PageNotFound/PageNotFound";

function App() {
  return (
    <div>
      <Routes>
        {privateRoutes?.map((item, i) => {
          return (
            <Route
              key={i}
              path={item?.route}
              caseSensitive
              element={<PrivateRoute>{item.component}</PrivateRoute>}
            />
          );
        })}

        <Route exact path="/" element={<Login />} />
        <Route exact path="/*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default App;
